<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-4 col-md-12 col-4">
                    <h2 v-if="!isMoneyLine">Customers</h2>
                    <h2 v-if="isMoneyLine">Accounts</h2>
                    </div>
                    <div class="col-lg-8 col-md-12 col-8 text-right">
                        <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                            <i @click="searchCustomer()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                            <input v-on:keyup.enter="searchCustomer" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search by customer name or account" aria-label="Search">
                            <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>
                        <button :disabled="spreadUploadStatus == 'INPROGRESS'" v-if="!isMoneyLine" @click="openImportCustomerModal()" type="button" class="btn btn-secondary rounded">
                            <div v-if="spreadUploadStatus == 'INPROGRESS'" style="color:black">
                              <i class="fa fa-spinner fa-spin"></i>  IMPORTING..
                            </div> 
                            <div v-if="!spreadUploadStatus">
                              <i class="fas fa-upload"></i> PRICE CHANGES IMPORT
                            </div> 
                        </button>
                        <button v-if="!isMoneyLine"  @click="openAddCustomerModal()" type="button" class="btn btn-secondary rounded"><i class="fas fa-user-plus"></i> ADD NEW CUSTOMER</button>              
                    </div>
                </div>                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl imstbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'customerFirstName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'customerFirstName'  ? 'sort-desc' : '']"  
                                    @click="sort('customerFirstName')" >Customer Name</th>
                               <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'customerType'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'customerType'  ? 'sort-desc' : '']"  
                                    @click="sort('customerType')" >Account/Type</th>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'customerEmail'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'customerEmail'  ? 'sort-desc' : '']"  
                                    @click="sort('customerEmail')" >Customer Email</th>        
                                <th 
                                    scope="col" 
                                    class="text-center">Action</th>
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="totalRows == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="customer in customers" :key="customer.id" >
                                <td class="text-primary">{{customer.customerFirstName ? customer.customerFirstName[0] : ""}}. {{customer.customerLastName}}</td>
                                <td>
                                    <div class="listAcc" v-for="(account,index) in customer.accountNames" :key="index" v-show="index < 2">
                                        {{account}}
                                    </div>
                                    <span  @click="openAddAccountModal(customer)" class="dropdown-item moreAcc" v-show="customer.accountNames.length > 2">
                                        ({{customer.accountNames.length - 2 }} More)
                                    </span>
                                    <span v-if="customer.accountNames.length == 0 ">N/A</span>
                                </td>
                                <!-- <td>
                                    <div class="listAcc" v-for="(account,index) in customer.customerEmails" :key="index" v-show="index < 2">
                                        {{account.email}}
                                    </div>
                                    <span  @click="openCustomerContactsModal(customer)" class="dropdown-item moreAcc" v-show="customer.customerEmails.length > 2">
                                        ({{customer.customerEmails.length - 2 }} More)
                                    </span>
                                    <span v-if="customer.customerEmails.length == 0 ">N/A</span>
                                </td> -->
                                <td class="coupon text-center">{{customer.customerEmail ? customer.customerEmail : 'N/A'}}</td>
                                <td class="text-center">
                                    <div class="d-inline-flex"> 
                                        <a  @click="openAddCustomerModal(customer)" class="btn ibtn grn"><i class="fas fa-pencil-alt"></i></a>
                                        <div class="dropdown">
                                            <button class="btn ibtn blk dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i class="fas fa-ellipsis-v"></i>
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                                <button @click="openAddAccountModal(customer)" class="dropdown-item" type="button">Accounts</button>
                                                <button @click="openCustomerOfferingModal(customer)"   class="dropdown-item" type="button">Offerings</button>
                                                <button @click="openCustomerContactsModal(customer)"   class="dropdown-item" type="button">Contacts</button>
                                                <button @click="deleteCustomer(customer)" class="dropdown-item del" type="button">Delete</button>
                                            </div>
                                        </div>
                                    </div>    
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getCustomers(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
        <addcustomermodal 
            v-bind:customerData="customerData" 
            v-if="addCustomerModalOpen" 
            @close="closeAddcustomerModal()"/>
        <addaccountmodal
            v-bind:customerData="customerData"
            v-bind:isMoneyLine="isMoneyLine"
            v-if="addAccountModalOpen" 
            @close="closeAccountcustomerModal()"
         />
         <customerofferingmodal
            v-bind:customerData="customerData" 
            v-if="addCustomerOfferingModalOpen" 
            @close="addCustomerOfferingModalOpen = false"
         /> 
         <importcustomer 
            v-if="importCustomerModalOpen" 
            @close="closeImportCustomerModal()"
         />
         <CustomerContacts 
            v-if="customerContactsModalOpen" 
            v-bind:customerData="customerData"
            @close="closeCustomerEmailModal()"
         />   
    </div>    
</template>
<script>

import config from "@/config";
import authService from "@/authService";
import addcustomermodal from "./ImsAddCustomerModal";
import addaccountmodal from "./ImsAddCustomerAccountModal";
import customerofferingmodal from  "./ImsCustomerOfferings"
import importcustomer from "./ImsImportCustomer"
import CustomerContacts from "./ImsCustomerContactsModal"
export default {
  name: "imscustomers",
  components :{
    addcustomermodal,
    addaccountmodal,
    customerofferingmodal,
    importcustomer,
    CustomerContacts
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        sortColumn: "customerFirstName",
        sortOrder: "ASC",
        customers : [],
        addCustomerModalOpen : false,
        addAccountModalOpen : false,
        addCustomerOfferingModalOpen : false,
        importCustomerModalOpen : false,
        customerData :{},
        isMoneyLine: window.location.pathname.includes('moneyline'),
        customerContactsModalOpen : false,
        spreadUploadStatus : localStorage.getItem("SPREADUPLOADSTATUS")
    };
  },
  methods: {

    closeImportCustomerModal(){
        this.importCustomerModalOpen = false;
        this.getCustomers(); 
        this.spreadUploadStatus = localStorage.getItem("SPREADUPLOADSTATUS");

    },
    closeAddcustomerModal(){
        this.addCustomerModalOpen = false;
        this.getCustomers(this.currentPage); 
    },
    closeAccountcustomerModal(){
        this.addAccountModalOpen = false;
        this.getCustomers(); 
    },
    openAddCustomerModal(selectedCustomer){
        if(selectedCustomer){
            this.customerData = {...selectedCustomer};
        }else{
            this.customerData = {};
        }
        this.addCustomerModalOpen = !this.addCustomerModalOpen
    },
    openAddAccountModal(selectedCustomer){
        this.customerData =  {...selectedCustomer};
        this.addAccountModalOpen = !this.addAccountModalOpen
    },
    openImportCustomerModal(){
        this.importCustomerModalOpen = !this.importCustomerModalOpen
    },
    openCustomerOfferingModal(selectedCustomer){
        this.customerData =  {...selectedCustomer};
        this.addCustomerOfferingModalOpen = !this.addCustomerOfferingModalOpen
    },
    openCustomerContactsModal(selectedCustomer){
        this.customerData =  {...selectedCustomer};
        this.customerContactsModalOpen = !this.customerContactsModalOpen
    },
    closeCustomerEmailModal(){
        this.customerContactsModalOpen = !this.customerContactsModalOpen;
        this.getCustomers(); 
    },
    deleteCustomer(customer){
        var message = "Are you sure you want to delete this customer?";

        this.$confirm(message,"Delete customer","",{confirmButtonText:"Delete",cancelButtonText : "No"}).then(() => {
            this.loading = true;
            var data = { "id":customer.id,"status":"DEACTIVE"}
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            this.$http
            .put(config.baseUrlBidSide + "/customer/status", data, auth)
            .then((result) => {
                if(result.data == "You can't delete this customer as it is part of an account"){
                    this.$alert(result.data)
                }
                this.loading = false;              
                this.getCustomers();              
            })
            .catch(() => {
                this.loading = false;              
            });
        });

    },
    searchCustomer(){
        this.getCustomers(); 
    },
    clearSearch(){
        this.searchValue = "";
        this.getCustomers(); 
    },
    sort(column){
        this.sortColumn = column;
        this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
        this.getCustomers();
    },

    getCustomers(){
        this.loading = true;
       
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/customer/list?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=ACTIVE"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder,
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          this.customers = result.data.content;
          this.loading = false;
        })
    }
   
  },
  mounted() {
    this.getCustomers();
    this.$root.$on("SPREADUPLOADCOMPLETED", () => {
      this.spreadUploadStatus = null;
    });
  }
};
</script>